<template>
    <div>
        <Breadcrumbs main="Procurement" title="Vendor Details" />
    
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div style="display: flex; flex-direction: row; gap: 40px;  align-items: center; background-color: rgb(243 244 246); border-radius: 0.75rem; filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06)); padding: 20px;">
                                <img style="height: 100px; width: 100px; border-radius: 100%;" :src="clients.image">
                                <div style="margin-top: 15px; display: flex; flex-direction: column;">
                                    <h5>{{ details.user.first_name }}</h5>
                                    <h7>Email: {{ details.user.email }}</h7>
                                    <h7>Phone: {{ details.phone }}</h7>
                                    <h7>Company: {{ details.company }}</h7>
                                    <h7>Address: {{ details.address }}</h7>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div style="display: flex; flex-direction: row; gap: 10px; cursor: pointer;">
                                <h7 @click="toggleItem('Documents')" :class="{ active: activeItem === 'Documents' }">Supporting Documents</h7>
                                <h7 @click="toggleItem('Projects')" :class="{ active: activeItem === 'Projects' }">Projects</h7>
                                <h7 @click="toggleItem('Po')" :class="{ active: activeItem === 'Po' }">Purchase Order</h7>
                                <h7 @click="toggleItem('Bill')" :class="{ active: activeItem === 'Bill' }">Bill</h7>
                            </div>
                        </div>
    
                        <div class="card" v-if="activeItem === 'Po'">
                            <div class="card-body">
                                <b-row>
                                    <b-col xl="6">
                                        <b-input-group class="datatable-btn">
                                            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                            <b-input-group-append>
                                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                    
                                    <b-col xl="6">
                                        <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                
                                <div class="table-responsive datatable-vue">
                                    <b-table
                                        show-empty
                                        stacked="md"
                                        :items="details.po"
                                        :fields="tablefieldsPurchaseOrder"
                                        :filter="filter"
                                        :current-page="currentPage"
                                        :per-page="perPage"
                                        @filtered="onFiltered"
                                    >
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
                                    </b-table>
                                </div>
                
                                <b-col md="6" class="my-1 p-0">
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="perPage"
                                        class="my-0"
                                    ></b-pagination>
                                </b-col>
                            </div>
                        </div>
                        <div class="card" v-if="activeItem === 'Bill'">
                            <div class="card-body">
                                <b-row>
                                    <b-col xl="6">
                                        <b-input-group class="datatable-btn">
                                            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                            <b-input-group-append>
                                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                    
                                    <b-col xl="6">
                                        <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                
                                <div class="table-responsive datatable-vue">
                                    <b-table
                                        show-empty
                                        stacked="md"
                                        :items="details.bill"
                                        :fields="tablefieldsBill"
                                        :filter="filter"
                                        :current-page="currentPage"
                                        :per-page="perPage"
                                        @filtered="onFiltered"
                                    >
    
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
                                    </b-table>
                                </div>
                
                                <b-col md="6" class="my-1 p-0">
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="perPage"
                                        class="my-0"
                                    ></b-pagination>
                                </b-col>
                            </div>
                        </div>
                        <div class="card" v-if="activeItem === 'Projects'">
                            <div class="card-body">
                                <b-row>
                                    <b-col xl="6">
                                        <b-input-group class="datatable-btn">
                                            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                            <b-input-group-append>
                                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                    
                                    <b-col xl="6">
                                        <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                
                                <div class="table-responsive datatable-vue">
                                    <b-table
                                        show-empty
                                        stacked="md"
                                        :items="details.projects"
                                        :fields="tablefieldsProjects"
                                        :filter="filter"
                                        :current-page="currentPage"
                                        :per-page="perPage"
                                        @filtered="onFiltered"
                                    >
    
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>

                                         <template #cell(lead)="data">
                                            <div style="display: flex; flex-direction: column; gap: 5px;">
                                                <h7>{{ data.item?.project_id?.created_by?.full_name }}</h7>
                                                <h7>{{ data.item?.project_id?.created_by?.email }}</h7>
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                
                                <b-col md="6" class="my-1 p-0">
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="perPage"
                                        class="my-0"
                                    ></b-pagination>
                                </b-col>
                            </div>
                        </div>
                        <div class="card" v-if="activeItem === 'Documents'">
                            <div class="card-body">
                                <b-button variant="primary" style="margin-bottom: 24px;" v-b-modal.modal-scrollable-add-document>Add Document</b-button>
                                <b-row>
                                    <b-col xl="6">
                                        <b-input-group class="datatable-btn">
                                            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                            <b-input-group-append>
                                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                    
                                    <b-col xl="6">
                                        <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                
                                <div class="table-responsive datatable-vue">
                                    <b-table
                                        show-empty
                                        stacked="md"
                                        :items="details.supporting_documents"
                                        :fields="tablefieldsDocuments"
                                        :filter="filter"
                                        :current-page="currentPage"
                                        :per-page="perPage"
                                        @filtered="onFiltered"
                                    >
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>

                                         <template #cell(attachment)="data">
                                            <div>
                                                <a :href="host + data.item?.employee_attachment" target="_blank" rel="noopener noreferrer">
                                                    {{ host + data.item?.employee_attachment }}
                                                </a>
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                
                                <b-col md="6" class="my-1 p-0">
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="perPage"
                                        class="my-0"
                                    ></b-pagination>
                                </b-col>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <b-modal id="modal-scrollable-add-document" ref="modal" title="Add Document" @ok="handleAttachOk">
                <form ref="form" @submit.stop.prevent="handleAttahmentSubmit">
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Upload Document</label>
                                <b-form-file placeholder="Choose files  or drop them here..." drop-placeholder="Drop file here..." @change="uploadAttachFile"></b-form-file>
                            </div>
                        </div>
                    </div>
                </form>
            </b-modal>
        </div>
    </div>
</template>
    
<script>
import { mapState } from 'vuex';
import { myHost } from "../../../_helpers/host";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import img1 from "../../../assets/images/user/3.jpg";

export default {
    data() {
        return {
            host: myHost.host,
            activeItem:'Documents',
            img1: img1,
            attachment: null,
            user_id: null,
            clients: {
                id: 1,
                name: 'Rasel Mir',
                phone_no: '+8801785457487',
                email: 'rasel@test.com',
                image: img1
            },
            tablefieldsPurchaseOrder: [
                { key: 'index', label: '#' },
                {key: 'purchase_order_id', label: 'Purchase Order ID', sortable: true,},
                {key: 'purchase_order_date', label: 'Purchase Order Date', sortable: true,},
                {key: 'subtotal', label: 'Purchase Order Date', sortable: true,},
                {key: 'purchase_order_date', label: 'Purchase Order Date', sortable: true,},
                {key: 'subtotal', label: 'Subtotal', sortable: true },
                {key: 'total', label: 'Total', sortable: true }
            ],
            tablefieldsBill: [
                { key: 'index', label: '#' },
                { key: 'bill_id', label: 'Bill ID', sortable: true },
                { key: 'email', label: 'Email', sortable: true },
                { key: 'bill_date', label: 'Bill Date', sortable: true },
                { key: 'due_date', label: 'Due Date', sortable: true },
                { key: 'subtotal', label: 'Grand Total', sortable: true } 
            ],
            tablefieldsProjects: [
                { key: 'index', label: '#' },
                { key: 'project_id.title', label: 'Name', sortable: true },
                { key: 'lead', label: 'Project Lead', sortable: true },
                { key: 'project_id.start_date', label: 'Start Date', sortable: true },
                { key: 'project_id.end_date', label: 'End Date', sortable: true },
                { key: 'project_id.status', label: 'Status', sortable: true }
            ],
            tablefieldsDocuments: [
                { key: 'index', label: '#' },
                { key: 'attachment', label: 'Document', sortable: true }
            ],

            invoices:[
                {
                    invoice_id:'',
                }
            ],

            filter: null,
    
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100]   
        };
    },

    computed: {
        ...mapState({
            details: state => state.vendor.vendorDetails
        }),

        sortOptions() {
            return this.tablefields
            .filter(f => f.sortable)
            .map(f => {
                return {text: f.label, value: f.key};
            });
        }
    },

    mounted() {
        this.$store.dispatch("vendor/fetchVendorDetails", this.$route.params.id)
    },

    methods: {
        toggleItem(item) {
            this.activeItem = item;
        },

        uploadAttachFile(e) {
            this.attachment = e.target.files[0]
        },

        handleAttachOk(bvModalEvent) { 
            bvModalEvent.preventDefault()
            this.handleAttahmentSubmit()
        },

        handleAttahmentSubmit() {
            this.user_id = this.details.user.id

            this.$store.dispatch("vendor/addVendorAttachment", {
                employee_attachment: this.attachment,
                user_id: this.user_id,
                vendor_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.attachment = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable-add-document')
            })
        }
    }
}
</script>
    
<style scoped>
.active{
    color: #ff595d;
}
</style>
    